import search from "./search";
import searchResult from "./search_result";
import lead from "./lead";
import profile from "./profile";
import tracker from "./tracker"

export default [ search, searchResult, lead, tracker, profile ];
